import React from "react";
import autobind from "class-autobind";
import { ETrendTimeScope, IGroupedTrend } from "../../../models/data/dashboard/Trends/TrendsData";
import { RaisedButton, IconButton, FontIcon } from "material-ui";
import IconDatePicker from "../../../components/common/IconDatePicker"; // Adjust the import path as needed
import { IDate } from "../../../models";
import moment from "moment";

declare global {
    interface Window {
        Intercom: any;
    }
}

interface IProps {
    startDate: IDate; // New: startDate prop
    endDate: IDate; // New: endDate prop
    data: IGroupedTrend;
    scope: ETrendTimeScope;
    onScopeChange(newScope: ETrendTimeScope): void;
    updateDateRange(startDate: IDate, endDate: IDate): void; // New: Function to update date range
}

interface IState {
    startDate: IDate;
    endDate: IDate;
}

export default class TrendDetailsHeader extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
        this.state = {
            startDate: this.props.startDate,
            endDate: this.props.endDate,
        };
        autobind(this);
    }

    componentDidMount() {}

    componentWillUnmount() {}

    // Convert the data array to a CSV string
    arrayToCSV(data) {
        return data.map((row) => row.join(",")).join("\n");
    }

    // Trigger the CSV download
    downloadCSV(filename, csvContent) {
        const blob = new Blob([this.arrayToCSV(csvContent)], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    }

    handleStartDateChange(date) {
        this.setState({ startDate: date });
        this.props.updateDateRange(date, this.state.endDate);
    }

    handleEndDateChange(date) {
        this.setState({ endDate: date });
        this.props.updateDateRange(this.state.startDate, date);
    }

    render() {
        const data = this.props.data;
        const greenColor = "#3AAD07";
        const selectedBackgroundColor = "#1181F2";
        const selectedTextColor = "#ffffff";
        const unSelectedBackgroundColor = "#cecece";
        const unSelectedTextColor = null; // "#D0D0D0";

        return (
            <div style={{ padding: 5, paddingLeft: 10 }}>
                {data && (
                    <div>
                        <div style={{ display: "grid", alignItems: "center", padding: 10 }}>
                            <div style={{ gridColumn: 1, gridRow: "auto" }}>
                                <div
                                    style={{
                                        marginBottom: 0,
                                        marginTop: 0,
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        fontSize: 20,
                                    }}
                                >
                                    <IconButton
                                        data-intercom-target={"PunchSet-Exceptions-Report"}
                                        tooltip={"Download CSV"}
                                        style={{ marginRight: 15, padding: 2, width: 35, height: 35 }}
                                        onClick={() => {
                                            let report = [
                                                [
                                                    "Name",
                                                    "Date",
                                                    data.Settings.UnitName,
                                                    data.Settings.AggregationSettings.NumeratorName,
                                                    data.Settings.AggregationSettings.DenominatorName,
                                                ],
                                            ];

                                            this.props.data.SeriesData.forEach((item) => {
                                                report.push([
                                                    this.props.data.HierarchyName,
                                                    moment(item.DateTime).format("MM/DD/YYYY"),
                                                    item.Value.toString(),
                                                    item.Numerator.toString(),
                                                    item.Denominator.toString(),
                                                ]);
                                            });

                                            this.downloadCSV(
                                                `${data.Settings.Name}-${data.HierarchyName}.csv`,
                                                report
                                            );
                                        }}
                                    >
                                        <FontIcon
                                            className="fa-solid fa-download itemActionButton"
                                            style={{ fontSize: 16 }}
                                        />
                                    </IconButton>
                                    {data.Settings.Name} - {data.HierarchyName}
                                </div>
                                <p style={{ marginTop: 0, fontSize: 10 }}>{data.Settings.Description}</p>
                            </div>
                            <div style={{ gridColumn: 2, gridRow: "auto", textAlign: "right" }}>
                                <IconDatePicker
                                    label="Start Date"
                                    date ={this.state.startDate}
                                    handleSelectDate ={this.handleStartDateChange}
                                />
                                <IconDatePicker
                                    label="End Date"
                                    date ={this.state.endDate}
                                    handleSelectDate={this.handleEndDateChange}
                                />
                            </div>
                        </div>
                        <div style={{ paddingTop: 5, position: "relative", maxWidth: 700 }}>
                            <div style={{ display: "flex" }}>
                                {data &&
                                    data.Settings &&
                                    data.Settings.TimeScopes.includes(ETrendTimeScope.Daily) && (
                                        <div style={{ flex: 1, textAlign: "center", paddingRight: 5 }}>
                                            <RaisedButton
                                                backgroundColor={
                                                    this.props.scope === ETrendTimeScope.Daily
                                                        ? selectedBackgroundColor
                                                        : unSelectedBackgroundColor
                                                }
                                                labelColor={
                                                    this.props.scope === ETrendTimeScope.Daily
                                                        ? selectedTextColor
                                                        : unSelectedTextColor
                                                }
                                                label={"1D"}
                                                style={{ width: 30, marginTop: 0 }}
                                                onTouchTap={() => {
                                                    this.props.onScopeChange(ETrendTimeScope.Daily);
                                                }}
                                            />
                                        </div>
                                    )}

                                {data &&
                                    data.Settings &&
                                    data.Settings.TimeScopes.includes(ETrendTimeScope.Weekly) && (
                                        <div style={{ flex: 1, textAlign: "center", paddingRight: 5 }}>
                                            <RaisedButton
                                                backgroundColor={
                                                    this.props.scope === ETrendTimeScope.Weekly
                                                        ? selectedBackgroundColor
                                                        : unSelectedBackgroundColor
                                                }
                                                labelColor={
                                                    this.props.scope === ETrendTimeScope.Weekly
                                                        ? selectedTextColor
                                                        : unSelectedTextColor
                                                }
                                                label={"1W"}
                                                style={{ width: 30, marginTop: 0 }}
                                                onTouchTap={() => {
                                                    this.props.onScopeChange(ETrendTimeScope.Weekly);
                                                }}
                                            />
                                        </div>
                                    )}

                                {data &&
                                    data.Settings &&
                                    data.Settings.TimeScopes.includes(ETrendTimeScope.Monthly) && (
                                        <div style={{ flex: 1, textAlign: "center", paddingRight: 5 }}>
                                            <RaisedButton
                                                backgroundColor={
                                                    this.props.scope === ETrendTimeScope.Monthly
                                                        ? selectedBackgroundColor
                                                        : unSelectedBackgroundColor
                                                }
                                                labelColor={
                                                    this.props.scope === ETrendTimeScope.Monthly
                                                        ? selectedTextColor
                                                        : unSelectedTextColor
                                                }
                                                label={"1M"}
                                                style={{ width: 30, marginTop: 0 }}
                                                onTouchTap={() => {
                                                    this.props.onScopeChange(ETrendTimeScope.Monthly);
                                                }}
                                            />
                                        </div>
                                    )}

                                {data &&
                                    data.Settings &&
                                    data.Settings.TimeScopes.includes(ETrendTimeScope.Quarterly) && (
                                        <div style={{ flex: 1, textAlign: "center", paddingRight: 5 }}>
                                            <RaisedButton
                                                backgroundColor={
                                                    this.props.scope === ETrendTimeScope.Quarterly
                                                        ? selectedBackgroundColor
                                                        : unSelectedBackgroundColor
                                                }
                                                labelColor={
                                                    this.props.scope === ETrendTimeScope.Quarterly
                                                        ? selectedTextColor
                                                        : unSelectedTextColor
                                                }
                                                label={"3M"}
                                                style={{ width: 30, marginTop: 0 }}
                                                onTouchTap={() => {
                                                    this.props.onScopeChange(ETrendTimeScope.Quarterly);
                                                }}
                                            />
                                        </div>
                                    )}

                                {data &&
                                    data.Settings &&
                                    data.Settings.TimeScopes.includes(ETrendTimeScope.SemiAnnualy) && (
                                        <div style={{ flex: 1, textAlign: "center", paddingRight: 5 }}>
                                            <RaisedButton
                                                backgroundColor={
                                                    this.props.scope === ETrendTimeScope.SemiAnnualy
                                                        ? selectedBackgroundColor
                                                        : unSelectedBackgroundColor
                                                }
                                                labelColor={
                                                    this.props.scope === ETrendTimeScope.SemiAnnualy
                                                        ? selectedTextColor
                                                        : unSelectedTextColor
                                                }
                                                label={"6M"}
                                                style={{ width: 30, marginTop: 0 }}
                                                onTouchTap={() => {
                                                    this.props.onScopeChange(ETrendTimeScope.SemiAnnualy);
                                                }}
                                            />
                                        </div>
                                    )}

                                {data &&
                                    data.Settings &&
                                    data.Settings.TimeScopes.includes(ETrendTimeScope.Annualy) && (
                                        <div style={{ flex: 1, textAlign: "center" }}>
                                            <RaisedButton
                                                backgroundColor={
                                                    this.props.scope === ETrendTimeScope.Annualy
                                                        ? selectedBackgroundColor
                                                        : unSelectedBackgroundColor
                                                }
                                                labelColor={
                                                    this.props.scope === ETrendTimeScope.Annualy
                                                        ? selectedTextColor
                                                        : unSelectedTextColor
                                                }
                                                label={"1Y"}
                                                style={{ width: 30, marginTop: 0 }}
                                                onTouchTap={() => {
                                                    this.props.onScopeChange(ETrendTimeScope.Annualy);
                                                }}
                                            />
                                        </div>
                                    )}
                            </div>
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
